module.exports = __webpack_public_path__ + "img/vote_example_sort.0865bb2c.jpg";